import { createSlice, createSelector } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { mergeMap, map, catchError } from "rxjs/operators";
const BannerFrontendIdentifier = {
  mainPage: "mainPage",
  casinoPage: "casinoPage",
  liveCasinoPage: "liveCasinoPage",
  sportPage: "sportPage",
  mainPageSportBlockSmall: "mainPageSportBlockSmall",
  mainPageSportBlockBig: "mainPageSportBlockBig",
  mainPageLiveCasinoBlockSmall: "mainPageLiveCasinoBlockSmall",
  mainPageLiveCasinoBlockBig: "mainPageLiveCasinoBlockBig",
  stories: "stories",
  mainPageMobileAdd: "mainPageMobileAdd",
  casino: "casino",
  casinoBanner: "casinoBanner",
  liveCasinoBanner: "liveCasinoBanner",
  registration: "registration",
  registration0: "registrationNoBonus",
  registration1: "registrationSport",
  registration2: "registrationCasino",
  registrationComplete: "registrationComplete",
  oneStepRegistration0: "oneStepRegistrationNoBonus",
  oneStepRegistration1: "oneStepRegistrationSport",
  oneStepRegistration2: "oneStepRegistrationCasino",
  asiaOneStepRegistration0: "asiaOneStepRegistrationNoBonus",
  asiaOneStepRegistration1: "asiaOneStepRegistrationSport",
  asiaOneStepRegistration2: "asiaOneStepRegistrationCasino",
  emptyMobileCoupon: "emptyMobileCoupon",
  instructionsDownloadingPwaIosSteps: "instructionsDownloadingPwaIosSteps",
  instructionsDownloadingPwaIosImages: "instructionsDownloadingPwaIosImages",
  login: "login",
  casinoBannerRedesign: "casinoBannerRedesign",
  liveCasinoBannerRedesign: "liveCasinoBannerRedesign"
};
var BannerAlignment = /* @__PURE__ */ ((BannerAlignment2) => {
  BannerAlignment2["left"] = "left";
  BannerAlignment2["center"] = "center";
  BannerAlignment2["right"] = "right";
  return BannerAlignment2;
})(BannerAlignment || {});
var BannerType = /* @__PURE__ */ ((BannerType2) => {
  BannerType2["casino"] = "casino";
  BannerType2["sport"] = "sport";
  return BannerType2;
})(BannerType || {});
var BannerButtonRouteType = /* @__PURE__ */ ((BannerButtonRouteType2) => {
  BannerButtonRouteType2["direct_link"] = "direct_link";
  BannerButtonRouteType2["sign_up"] = "sign_up";
  BannerButtonRouteType2["cashier"] = "cashier";
  BannerButtonRouteType2["login"] = "login";
  return BannerButtonRouteType2;
})(BannerButtonRouteType || {});
const BANNERS_FEATURE_KEY = "banners";
const initialBannersState = {
  banners: [],
  loaded: false,
  error: null,
  smartBanner: null,
  bannerLoaded: {}
};
const bannersSlice = createSlice({
  name: BANNERS_FEATURE_KEY,
  initialState: initialBannersState,
  reducers: {
    getBannerStart: (state) => {
      state.loaded = false;
    },
    getBannerSuccess: (state, action) => {
      const { frontendIdentifier, banner } = action.payload;
      const index = state.banners.findIndex((item) => item.frontendIdentifier === frontendIdentifier);
      if (index !== -1) {
        state.banners[index] = { frontendIdentifier, banner };
      } else {
        state.banners.push({ frontendIdentifier, banner });
      }
      state.loaded = true;
      state.bannerLoaded = { ...state.bannerLoaded, [frontendIdentifier]: true };
    },
    getBannerFailure: (state, action) => {
      const { frontendIdentifier } = action.payload;
      state.error = action.payload;
      state.bannerLoaded = { ...state.bannerLoaded, [frontendIdentifier]: true };
    },
    getSmartBannerStart: (state, action) => {
    },
    setSmartBannerData: (state, action) => {
      state.smartBanner = action.payload;
    },
    clearSmartBannerData: (state) => {
      state.smartBanner = null;
    }
  }
});
const bannersReducer = bannersSlice.reducer;
const {
  getSmartBannerStart,
  getBannerStart,
  getBannerSuccess,
  getBannerFailure,
  setSmartBannerData,
  clearSmartBannerData
} = bannersSlice.actions;
const getBannersState = (rootState) => rootState[BANNERS_FEATURE_KEY];
const selectBannerByFrontendIdentifier = createSelector(
  getBannersState,
  (s, frontendIdentifier) => frontendIdentifier,
  (s, frontendIdentifier) => {
    var _a, _b;
    return (_b = (_a = s.banners) == null ? void 0 : _a.find((banner) => banner.frontendIdentifier === frontendIdentifier)) == null ? void 0 : _b.banner;
  }
);
const selectBannerLoaded = createSelector(
  getBannersState,
  (s) => s.loaded
);
const selectBannerError = createSelector(
  getBannersState,
  (s) => s.error
);
const selectSmartBanner = createSelector(
  getBannersState,
  (s) => s.smartBanner
);
const selectBannerLoadedByFrontendIdentifier = createSelector(
  getBannersState,
  (s, frontendIdentifier) => frontendIdentifier,
  (s, frontendIdentifier) => !!s.bannerLoaded[frontendIdentifier]
);
const bannerByFrontendIdentifierEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getBannerStart.type),
  mergeMap((action) => Api.cms.getBanner(action).pipe(
    map((results) => getBannerSuccess({ frontendIdentifier: action.payload.frontendIdentifier, banner: results })),
    catchError((err) => of(getBannerFailure({ ...err, frontendIdentifier: action.payload.frontendIdentifier })))
  ))
);
const fetchBannerByFrontendIdentifier = (params) => ({
  type: getBannerStart.type,
  payload: params
});
const fetchSmartBannerEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getSmartBannerStart.type),
  mergeMap(() => Api.cms.getSmartBanner().pipe(
    map((results) => setSmartBannerData(results)),
    catchError((err) => of(getBannerFailure(err)))
  ))
);
const fetchSmartBanner = () => ({
  type: getSmartBannerStart.type
});
export {
  BANNERS_FEATURE_KEY,
  BannerAlignment,
  BannerButtonRouteType,
  BannerFrontendIdentifier,
  BannerType,
  bannerByFrontendIdentifierEpic,
  bannersReducer,
  bannersSlice,
  clearSmartBannerData,
  fetchBannerByFrontendIdentifier,
  fetchSmartBanner,
  fetchSmartBannerEpic,
  getBannerFailure,
  getBannerStart,
  getBannerSuccess,
  getBannersState,
  getSmartBannerStart,
  initialBannersState,
  selectBannerByFrontendIdentifier,
  selectBannerError,
  selectBannerLoaded,
  selectBannerLoadedByFrontendIdentifier,
  selectSmartBanner,
  setSmartBannerData
};
